import React from 'react';
import { CardOrganizationShortInfoProps } from './types';
import { Avatar, Info, Wrapper } from './card-organization-short-info.styles';
import { AllLock, TransfersAddressManagementCompanyPIF } from '@vtbhome/juicyfront/indexIcon';
import { COLORS } from '@shared/config/colors/colors';
import { Typography } from '@shared/ui/typography/typography';
import { getOrganizationStatus } from '@shared/lib/utils/get-organization-status/get-organization-status';

export const CardOrganizationShortInfo: React.FC<CardOrganizationShortInfoProps> = ({ organization }) => {
    return (
        <Wrapper>
            <Avatar>
                {getOrganizationStatus(organization) === 'disabled' ? (
                    <AllLock color={COLORS.neutral_50} />
                ) : (
                    <TransfersAddressManagementCompanyPIF size='s' color={COLORS.neutral_50} />
                )}
            </Avatar>
            <Info>
                <Typography size='h6' color='neutral_70'>
                    {organization.shortName}
                </Typography>
                <Typography size='body1_short' color='neutral_50'>
                    ИНН {organization.inn}, КПП {organization.kpp}
                </Typography>
            </Info>
        </Wrapper>
    );
};
